module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_5_3.76b5b1d2.jpeg";